import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL } from '../data/content';
interface Step {
  number: string;
  title: string;
  description: string;
  note?: string;
}
const steps: Step[] = [{
  number: '01',
  title: 'Realizá tu compra',
  description: 'Presioná el botón de acceso y completá el pago seguro por USD 12.',
  note: 'Antes de confirmar la compra, la página convierte automáticamente el precio a tu moneda local.'
}, {
  number: '02',
  title: 'Recibí el acceso',
  description: 'Después de confirmar el pago, recibirás las instrucciones para acceder a todos los archivos digitales.'
}, {
  number: '03',
  title: 'Descargá los materiales',
  description: 'Accedé a la guía principal, al documento “Empezá acá” y a los ocho bonos incluidos.'
}, {
  number: '04',
  title: 'Elegí por dónde comenzar',
  description: 'Abrí primero “Empezá acá”, identificá qué necesitás y seleccioná una práctica o herramienta para ese momento.'
}, {
  number: '05',
  title: 'Volvé cuando lo necesites',
  description: 'Guardá los materiales y consultalos nuevamente cada vez que quieras realizar una práctica, un ritual o registrar tu experiencia.'
}];
export function HowItWorks() {
  return <section className="w-full bg-lavender px-5 py-12 sm:py-20" data-id="element-181" data-mp="2wj6bhglaxqc7">
      <div className="mx-auto max-w-6xl" data-id="element-182" data-mp="3abe4cx9gsx5m">
        <div className="mx-auto max-w-2xl text-center" data-id="element-183" data-mp="3aachlvj36m82">
          <span className="mb-5 inline-block rounded-full border border-gold/50 bg-card px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-plum" data-id="element-184" data-mp="36bbyebwp5hkj">
            Simple, digital e inmediato
          </span>
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-plum sm:text-4xl" data-id="element-185" data-mp="3fcjvwrre2edk">
            ¿Cómo accedés a Aura Viva 2026?
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-plum/75 sm:text-base" data-id="element-186" data-mp="1kxhcnbsxnsj3">
            Podés comprarlo desde cualquier país de Latinoamérica y comenzar a recorrer el material
            después de confirmar el pago.
          </p>
        </div>

        <ol className="mt-10 flex flex-col items-stretch gap-4 md:flex-row md:gap-3" data-id="element-187" data-mp="3pz3ho7gw88fp">
          {steps.map((step, i) => <React.Fragment key={step.number} data-id="element-188" data-mp="3u2i014sb10wb" data-mpi={i}>
              <motion.li initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.3,
            delay: i * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-1 flex-col rounded-2xl border border-aura/15 bg-card p-5 sm:p-6" data-id="element-189" data-mp="2ux40sbqn82k">
                <span className="font-serif-display text-3xl font-bold leading-none text-gold" data-id="element-190" data-mp="lkljre70qhxc">
                  {step.number}
                </span>
                <h3 className="mt-3 text-base font-bold leading-snug text-plum" data-id="element-191" data-mp="qhc104uk7jkc">{step.title}</h3>
                <p className="mt-2 flex-1 text-[13px] leading-relaxed text-plum/75 sm:text-sm" data-id="element-192" data-mp="vgf6trid5ttd">
                  {step.description}
                </p>
                {step.note && <p className="mt-3 border-t border-gold/30 pt-3 text-[12px] leading-relaxed text-aura" data-id="element-193" data-mp="10m25oihcl1s9">
                    {step.note}
                  </p>}
              </motion.li>
              {i < steps.length - 1 && <>
                  <span className="mx-auto h-5 w-px bg-aura/40 md:hidden" aria-hidden="true" data-id="element-194" data-mp="1od7lwyr79w33" />
                  <span className="hidden w-3 shrink-0 self-center border-t border-aura/40 md:block" aria-hidden="true" data-id="element-195" data-mp="1jdl6cinwg3r4" />
                </>}
            </React.Fragment>)}
        </ol>

        <p className="mx-auto mt-10 max-w-2xl text-center font-serif-display text-lg font-bold text-plum sm:text-xl" data-id="element-196" data-mp="273fj7087xsbd">
          Comprás una vez. Accedés de por vida.{' '}
          <span className="text-aura" data-id="element-197" data-mp="22bfnxl33fnl4">Comenzás a tu propio ritmo.</span>
        </p>

        <div className="mx-auto mt-8 w-full max-w-md" data-id="element-198" data-mp="1mtxsx134c403">
          <CTAButton label="QUIERO ACCEDER AHORA POR USD 12" href={CHECKOUT_URL} textClassName="text-[13px] tracking-tight sm:text-[16px] sm:tracking-normal" data-id="element-199" data-mp="1rtixbr1254k7" />
          <p className="mt-3 text-center text-xs text-plum/70 sm:text-sm" data-id="element-200" data-mp="1hv32bcywtb5f">
            Pago único · Acceso inmediato · Sin suscripción
          </p>
          <p className="mt-2 text-center text-xs leading-relaxed text-plum/70 sm:text-sm" data-id="element-201" data-mp="25lz2axdircnr">
            Disponible para toda Latinoamérica con conversión automática a tu moneda local.
          </p>
        </div>
      </div>
    </section>;
}